export const KEY_TOKEN = 'token';
export const KEY_URI_AFTER_AUTH = 'uri-after-auth';
